export default __webpack_public_path__ + "static/media/six.c9bcfcba.ogg";